import React from "react";
import { useDispatch } from "react-redux";
import {
  removeProductFromCart,
  updateProductQuantity,
} from "../../store/productSlice";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";
function CartItem({ data }) {
  const dispatch = useDispatch();

  return (
    <>
      <div className="rounded-xl w-full p-4 mt-5 border border-w-border">
        <div className="flex justify-between">
          <div className="flex">
            <div>
              <img className="w-36" src={data.image} alt="" loading="lazy" />
            </div>
            <div className="ml-2">
              <p className="text-xl font-medium">
                {defaultLang === "text_en" ? data.name : data.name_arabic}
              </p>
              <p className="text-xl font-medium">
                {data.final_price * data.quantity} SAR
              </p>
            </div>
          </div>

          <div className=" lg:mr-3 flex flex-col justify-center place-items-center">
            <button
              onClick={() =>
                dispatch(removeProductFromCart({ item_id: data.item_id }))
              }
            >
              <span className="material-symbols-outlined">
                <svg
                  className="fill-red-600 w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
                </svg>
              </span>
            </button>
            <div className="mt-5 flex">
              <button
                onClick={() =>
                  dispatch(
                    updateProductQuantity({
                      item_id: data.item_id,
                      quantity: data.quantity + 1,
                    })
                  )
                }
                className="bg-w-btn text-w-btn-text px-2 font-bold"
              >
                +
              </button>
              <span className="w-8 text-center block">{data.quantity}</span>
              <button
                onClick={() =>
                  dispatch(
                    updateProductQuantity({
                      item_id: data.item_id,
                      quantity: data.quantity - 1,
                    })
                  )
                }
                className="bg-w-btn text-w-btn-text px-2 font-bold"
              >
                -
              </button>
            </div>
          </div>
        </div>
        <div className="mt-2 space-y-2">
          {data.modifiers.map((mod) => (
            <div className="flex justify-between max-w-sm w-full border px-2 py-1">
              <p>{mod.modifier_name}</p>
              <p>{mod.modifier_price} SAR</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default CartItem;
